import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { FeedbackService, ToastService } from '@services';

@Component({
  selector: 'app-feedback-drawer',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './feedback-drawer.component.html',
  styleUrls: ['./feedback-drawer.component.scss'],
})
export class FeedbackDrawerComponent {
  protected isOpen = false;
  protected isSubmitting = false;
  protected form = {
    title: '',
    description: '',
  };

  constructor(
    private readonly feedback: FeedbackService,
    private readonly toast: ToastService,
    private readonly router: Router,
  ) {}

  protected get canSubmit(): boolean {
    return Boolean(this.form.title.trim() && this.form.description.trim() && !this.isSubmitting);
  }

  protected toggleDrawer(): void {
    this.isOpen = !this.isOpen;
  }

  protected closeDrawer(): void {
    this.isOpen = false;
  }

  protected async submit(): Promise<void> {
    if (!this.canSubmit) return;
    this.isSubmitting = true;
    try {
      const result = await this.feedback.submitFeedback({
        title: this.form.title,
        description: this.form.description,
        route: this.router.url,
        pageTitle: typeof document !== 'undefined' ? document.title : '',
      });
      const ticketLabel = result.card.ticketNumber ? `Ticket #${result.card.ticketNumber}` : 'Feedback ticket';
      if (result.agentify?.status === 'completed' && result.agentify.movedToBacklog) {
        this.toast.success(`${ticketLabel} agentified into ${result.column.title}.`, 'Feedback');
      } else if (result.agentify?.status === 'failed') {
        this.toast.warning(`${ticketLabel} added to ${result.column.title}. Agentify failed.`, 'Feedback');
      } else {
        this.toast.success(`${ticketLabel} added to ${result.column.title}.`, 'Feedback');
      }
      this.form = { title: '', description: '' };
      this.closeDrawer();
    } catch (err: any) {
      this.toast.error(String(err?.message ?? 'Could not submit feedback.'), 'Feedback');
    } finally {
      this.isSubmitting = false;
    }
  }

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (this.isOpen && !this.isSubmitting) {
      this.closeDrawer();
    }
  }
}
